document.addEventListener("DOMContentLoaded", () => {
  const copyButtons = document.querySelectorAll(".code-copy-btn");

  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const discountContainer = this.closest(".discount-code-box");
      const codeElement = discountContainer.querySelector(".discount-code");
      const copyText = this.querySelector(".copy-text");

      if (codeElement && copyText) {
        const code = codeElement.textContent.trim();
        navigator.clipboard.writeText(code).then(() => {
          copyText.textContent = "Copied";
          button.style.pointerEvents = "none";

          setTimeout(() => {
            copyText.textContent = 'Copy';
            button.style.pointerEvents = "auto";
          }, 3000);
        });
      }
    });
  });
});
